import { useState, useEffect } from 'react';

const STORAGE_KEY = 'uiPlaygroundSettings';

const DEFAULT_SETTINGS = {
  theme: 'light',
  comparisonMode: 'side-by-side', // or 'toggle'
  showGrid: false,
  showRulers: false,
};

/**
 * Hook for managing UI Playground settings
 * Persists to localStorage for session continuity
 */
export function useUIPlaygroundSettings() {
  const [settings, setSettings] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? { ...DEFAULT_SETTINGS, ...JSON.parse(stored) } : DEFAULT_SETTINGS;
    } catch (error) {
      console.warn('Failed to load UI Playground settings:', error);
      return DEFAULT_SETTINGS;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    } catch (error) {
      console.warn('Failed to save UI Playground settings:', error);
    }
  }, [settings]);

  const updateSettings = (updates) => {
    setSettings(prev => ({ ...prev, ...updates }));
  };

  const resetSettings = () => {
    setSettings(DEFAULT_SETTINGS);
  };

  return {
    settings,
    updateSettings,
    resetSettings,
  };
}
